import { apiClient } from '_app'
import { ApiResponse, PermissionDto } from 'dtos'

export const getPermissions = () =>
  apiClient.get<ApiResponse<PermissionDto[]>>('/api/permissions').then(response => response.data)
